/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AgentTool } from './AgentTool';
import {
    AgentToolFromJSON,
    AgentToolFromJSONTyped,
    AgentToolToJSON,
} from './AgentTool';
import type { CallingIdentity } from './CallingIdentity';
import {
    CallingIdentityFromJSON,
    CallingIdentityFromJSONTyped,
    CallingIdentityToJSON,
} from './CallingIdentity';

/**
 * 
 * @export
 * @interface CreateUpdateAgentRequestContent
 */
export interface CreateUpdateAgentRequestContent {
    /**
     * Name of the agent
     * @type {string}
     * @memberof CreateUpdateAgentRequestContent
     */
    name: string;
    /**
     * Description for the agent
     * @type {string}
     * @memberof CreateUpdateAgentRequestContent
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateAgentRequestContent
     */
    greeting: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateAgentRequestContent
     */
    language: string;
    /**
     * Tools attached to an agent
     * @type {Array<AgentTool>}
     * @memberof CreateUpdateAgentRequestContent
     */
    tools?: Array<AgentTool>;
    /**
     * 
     * @type {CallingIdentity}
     * @memberof CreateUpdateAgentRequestContent
     */
    callingIdentity: CallingIdentity;
}


/**
 * Check if a given object implements the CreateUpdateAgentRequestContent interface.
 */
export function instanceOfCreateUpdateAgentRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "greeting" in value;
    isInstance = isInstance && "language" in value;
    isInstance = isInstance && "callingIdentity" in value;

    return isInstance;
}

export function CreateUpdateAgentRequestContentFromJSON(json: any): CreateUpdateAgentRequestContent {
    return CreateUpdateAgentRequestContentFromJSONTyped(json, false);
}

export function CreateUpdateAgentRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateAgentRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
        'greeting': json['greeting'],
        'language': json['language'],
        'tools': !exists(json, 'tools') ? undefined : ((json['tools'] as Array<any>).map(AgentToolFromJSON)),
        'callingIdentity': CallingIdentityFromJSON(json['callingIdentity']),
    };
}

export function CreateUpdateAgentRequestContentToJSON(value?: CreateUpdateAgentRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'greeting': value.greeting,
        'language': value.language,
        'tools': value.tools === undefined ? undefined : ((value.tools as Array<any>).map(AgentToolToJSON)),
        'callingIdentity': CallingIdentityToJSON(value.callingIdentity),
    };
}

